import get from 'lodash/get'
import Ajax from 'src/ajax'

const path = 'package-medicine'

/**
 * Actions
 */
const FETCH_REQUEST = `${path}/fetch-request`
const FETCH_REQUEST_SUCCESS = `${path}/fetch-success`
const FETCH_REQUEST_FAIL = `${path}/fetch-fail`

const ACTION_REQUEST = `${path}/action-request`
const ACTION_REQUEST_SUCCESS = `${path}/action-success`
const ACTION_REQUEST_FAIL = `${path}/action-fail`
const ACTION_FETCH_DETAIL_SUCCESS = `${path}/action-fetch-detail-success`

const RESET_DETAIL = `${path}/reset-detail`

/**
 * Action Creators
 */

export const resetDetail = () => ({ type: RESET_DETAIL })

/**
 * Side Effects
 */
export const fetchList = (queries) => async (dispatch) => {
  dispatch({ type: FETCH_REQUEST })
  try {
    const options = {
      method: 'GET',
      url: path,
      params: queries,
    }
    const response = await Ajax(options)
    const list = response.data.package_medicines
    const total = response.data.total
    dispatch({ type: FETCH_REQUEST_SUCCESS, payload: { list, total } })
  } catch (error) {
    const error_text = get(error, 'response.data.error')
    // set fetching = false + error text
    dispatch({ type: FETCH_REQUEST_FAIL, payload: error_text })
  }
}

export const fetchDetail = (_id) => async (dispatch) => {
  dispatch({ type: ACTION_REQUEST })
  try {
    const options = {
      method: 'GET',
      url: path + '/' + _id,
    }
    const response = await Ajax(options)
    const detail = response.data.package_medicine
    dispatch({ type: ACTION_FETCH_DETAIL_SUCCESS, payload: detail })
  } catch (error) {
    const error_text = get(error, 'response.data.error')
    // set fetching = false + error text
    dispatch({ type: ACTION_REQUEST_FAIL, payload: error_text })
  }
}

export const createPromo = (payload) => async (dispatch) => {
  dispatch({ type: ACTION_REQUEST })
  try {
    const options = {
      method: 'POST',
      url: 'promotion-medicine',
      data: payload,
    }
    await Ajax(options)
    dispatch({ type: ACTION_REQUEST_SUCCESS })
  } catch (error) {
    const error_array = get(error, 'response.data.errors')
    dispatch({ type: ACTION_REQUEST_FAIL, payload: 'error' })
    throw error_array
  }
}

export const deletePromo = (_id) => async (dispatch) => {
  dispatch({ type: ACTION_REQUEST })
  try {
    const options = {
      method: 'DELETE',
      url: 'promotion-medicine/' + _id,
    }
    await Ajax(options)
    dispatch({ type: ACTION_REQUEST_SUCCESS })
  } catch (error) {
    const error_text = get(error, 'response.data.error')
    dispatch({ type: ACTION_REQUEST_FAIL, payload: error_text })
    throw error_text
  }
}

export const stopPromo = (_id, payload) => async (dispatch) => {
  dispatch({ type: ACTION_REQUEST })
  try {
    const options = {
      method: 'PUT',
      url: 'promotion-medicine/' + _id,
      data: payload,
    }
    await Ajax(options)
    dispatch({ type: ACTION_REQUEST_SUCCESS })
  } catch (error) {
    const error_text = get(error, 'response.data.error')
    dispatch({ type: ACTION_REQUEST_FAIL, payload: error_text })
    throw error_text
  }
}

/**
 * Initial State
 */
const initialState = {
  fetching: false,
  list: [],
  total: 0,
  // loading for create & edit
  processing: false,
  error: null,
  //
  detail: {},
}

/**
 * Reducer
 */
export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case FETCH_REQUEST:
      return { ...state, fetching: true, error: null }
    case FETCH_REQUEST_SUCCESS:
      return {
        ...state,
        fetching: false,
        list: action.payload.list,
        total: action.payload.total,
      }
    case FETCH_REQUEST_FAIL:
      return { ...state, fetching: false, error: action.payload }

    case ACTION_REQUEST:
      return { ...state, processing: true, error: null }
    case ACTION_REQUEST_SUCCESS:
      return { ...state, processing: false }
    case ACTION_REQUEST_FAIL:
      return { ...state, processing: false, error: action.payload }
    case ACTION_FETCH_DETAIL_SUCCESS:
      return { ...state, processing: false, detail: action.payload }
    case RESET_DETAIL:
      return { ...state, detail: initialState.detail }
    default:
      return state
  }
}
